module.exports = __webpack_public_path__ + "img/stamped.b3870f31.png";